import {
  AvatarCardLinkWidgetFields,
  AvatarCardLinkWidgetFormFields,
} from 'components/consumer-page-widgets/avatar-card-link-widget/AvatarCardLinkWidgetFormFields';
import { BaseWidgetFormFields } from 'components/consumer-page-widgets/BaseWidgetFormFields';
import { Button, Typography } from 'ui';
import { Form, Formik } from 'formik';
import { consumer } from '@tock/coretypes';
import {
  getBaseFormFieldsInitialValues,
  useUpdateNamedConfigurations,
} from 'components/consumer-page-widgets/widgetFormUtils';

import {
  widgetFormButtonContainer,
  widgetFormRoot,
} from 'components/consumer-page-widgets/widgetFormCssDefs';
import React, { FunctionComponent } from 'react';

interface UpdateAvatarCardLinkWidgetFormProps {
  selectedWidgetToEdit?: consumer.NamedConfiguration;
  onCompleteOrCancel(): void;
}

export const UpdateAvatarCardLinkWidgetForm: FunctionComponent<
  React.PropsWithChildren<UpdateAvatarCardLinkWidgetFormProps>
> = ({ selectedWidgetToEdit, onCompleteOrCancel }) => {
  const updateNamedConfig = useUpdateNamedConfigurations();

  if (!selectedWidgetToEdit?.avatarCardLinkWidgetConfig) {
    return null;
  }

  const { imageUrl, imageAlt, title, subtitle, linkText, linkHref } =
    selectedWidgetToEdit.avatarCardLinkWidgetConfig;

  const handleSubmit = (values: AvatarCardLinkWidgetFields) => {
    return updateNamedConfig({
      ...selectedWidgetToEdit,
      avatarCardLinkWidgetConfig: values,
    }).then(onCompleteOrCancel);
  };

  return (
    <>
      <Typography variant="heading1Bold">Editing widget: {selectedWidgetToEdit.name}</Typography>
      <Formik<AvatarCardLinkWidgetFields>
        enableReinitialize
        initialValues={{
          ...getBaseFormFieldsInitialValues({ widgetToEdit: selectedWidgetToEdit }),
          imageUrl: imageUrl ?? '',
          imageAlt: imageAlt ?? '',
          title: title ?? '',
          subtitle: subtitle ?? '',
          linkText: linkText ?? '',
          linkHref: linkHref ?? '',
        }}
        onSubmit={handleSubmit}
      >
        <Form css={widgetFormRoot}>
          <BaseWidgetFormFields />
          <AvatarCardLinkWidgetFormFields />
          <div css={widgetFormButtonContainer}>
            <Button type="submit">Submit</Button>
            <Button onClick={onCompleteOrCancel} type="button" variant="outlined">
              Cancel
            </Button>
          </div>
        </Form>
      </Formik>
    </>
  );
};
